import { Mixins, Component } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import Authentication from '@/views/Authentication/models/authentication'

@Component({})
export default class ImpersonateBanner extends Mixins<MixinInterface>() {
    loadingImpersonating = false

    async stopImpersonating() {
        if (this.loadingImpersonating) return

        this.loadingImpersonating = true
        await Authentication.impersonate(null)
        this.loadingImpersonating = false
    }
}
